type Props = {
  message: string;
};

export const LoginError = ({ message }: Props) => {
  return <div className="d-flex py-3 text-danger">{message}</div>;
};
